import i18n from 'i18next';

export default ({ isChildLocale = false }) => ({
  ...(!isChildLocale && {
    allow_public_view: {
      type: 'Boolean',
      label: i18n.t('public-view'),
      help: i18n.t('public-view-help'),
      labelText: i18n.t('allow-public-view'),
      placeholder: i18n.t('untitled-category'),
    },
  }),
});
